export default __webpack_public_path__ + "static/media/ArrowUp.d24f79e4.svg";